class WineSelector {
  constructor() {
    this.popup = document.querySelector('.wine-selector-popup');
    if (!this.popup) return;

    this.openBtns = document.querySelectorAll('[data-open-wine-selector]');
    this.closeBtns = this.popup.querySelectorAll('[data-close-wine-selector]');
    this.steps = this.popup.querySelectorAll('.wine-selector-step');
    this.options = this.popup.querySelectorAll('.wine-option');
    this.submitBtn = this.popup.querySelector('.wine-selector-submit');
    this.pairingContainer = this.popup.querySelector('[data-food-pairing-container]');

    this.selections = {
      collectionUrl: '',
      priceMin: null,
      priceMax: null,
      foodPairing: null
    };

    this.init();
  }

  init() {
    this.openBtns.forEach(btn => btn.addEventListener('click', () => this.open()));
    this.closeBtns.forEach(btn => btn.addEventListener('click', () => this.close()));
    
    this.popup.addEventListener('click', (e) => {
      const option = e.target.closest('.wine-option');
      if (option) this.handleOptionClick(option);
    });

    this.submitBtn.addEventListener('click', () => this.submit());
  }

  open() {
    this.popup.classList.add('is-active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.popup.classList.remove('is-active');
    document.body.classList.remove('overflow-hidden');
  }

  handleOptionClick(option) {
    const step = option.closest('.wine-selector-step');
    const stepNum = parseInt(step.dataset.step);

    // Toggle selection within the same step
    step.querySelectorAll('.wine-option').forEach(opt => opt.classList.remove('is-selected'));
    option.classList.add('is-selected');

    if (stepNum === 1) {
      this.selections.collectionUrl = option.dataset.collectionUrl;
      this.resetStepsAfter(1);
      
      const collMin = parseFloat(option.dataset.collectionMin) || 0;
      const collMax = parseFloat(option.dataset.collectionMax) || 999999;
      
      this.updatePriceOptions(collMin, collMax);
      this.enableStep(2);
      
      this.fetchFilters(this.selections.collectionUrl);
    } else if (stepNum === 2) {
      this.selections.priceMin = option.dataset.priceMin;
      this.selections.priceMax = option.dataset.priceMax;
      this.enableStep(3);
    } else if (stepNum === 3) {
      this.selections.foodPairing = option.dataset.value;
      this.validateSubmit();
    }
  }

  resetStepsAfter(stepNum) {
    for (let i = stepNum + 1; i <= 3; i++) {
      const step = this.popup.querySelector(`[data-step="${i}"]`);
      step.classList.add('is-disabled');
      step.querySelectorAll('.wine-option').forEach(opt => opt.classList.remove('is-selected'));
    }
    this.selections.priceMin = null;
    this.selections.priceMax = null;
    this.selections.foodPairing = null;
    this.validateSubmit();
  }

  enableStep(stepNum) {
    const step = this.popup.querySelector(`[data-step="${stepNum}"]`);
    step.classList.remove('is-disabled');
  }

  async fetchFilters(url) {
    this.pairingContainer.innerHTML = '<div class="wine-selector-loading">Loading pairings...</div>';
    
    try {
      const response = await fetch(url);
      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      // 2. Handle Food Pairing Step (Price logic moved to click handler)
      const pairingInputs = doc.querySelectorAll('input[name="filter.p.m.custom.food_pairings"]');
      if (pairingInputs.length > 0) {
        let htmlStr = '';
        pairingInputs.forEach(input => {
          let labelText = '';
          const parentLabel = input.closest('label');
          if (parentLabel) {
            const tagText = parentLabel.querySelector('.tag__text');
            labelText = tagText ? tagText.textContent.trim() : parentLabel.textContent.trim();
          } else {
            labelText = input.value;
          }

          if (labelText) {
            htmlStr += `<button type="button" class="wine-option" data-value="${input.value}">${labelText}</button>`;
          }
        });
        
        if (htmlStr) {
          this.pairingContainer.innerHTML = htmlStr;
        } else {
          this.pairingContainer.innerHTML = '<div class="wine-selector-loading">No specific pairings found in this category.</div>';
        }
      } else {
        this.pairingContainer.innerHTML = '<div class="wine-selector-loading">No specific pairings available for this wine type.</div>';
      }
    } catch (error) {
      console.error('Error fetching filters:', error);
      this.pairingContainer.innerHTML = '<div class="wine-selector-loading">Error loading data.</div>';
    }
  }

  updatePriceOptions(collMin, collMax) {
    const priceOptions = this.popup.querySelectorAll('[data-step="2"] .wine-option');
    let hasSelectedValid = false;
    let anyVisible = false;

    priceOptions.forEach(opt => {
      let optMinStr = opt.getAttribute('data-price-min');
      let optMaxStr = opt.getAttribute('data-price-max');
      
      const optMin = (optMinStr && optMinStr.trim() !== '') ? parseFloat(optMinStr) : 0;
      const optMax = (optMaxStr && optMaxStr.trim() !== '') ? parseFloat(optMaxStr) : 999999;

      const isAvailable = (optMin <= collMax) && (optMax >= collMin);

      if (isAvailable) {
        opt.classList.remove('is-hidden');
        opt.classList.remove('is-disabled');
        if (opt.classList.contains('is-selected')) hasSelectedValid = true;
        anyVisible = true;
      } else {
        opt.classList.add('is-hidden');
        opt.classList.add('is-disabled');
        opt.classList.remove('is-selected');
      }
    });

    if (!anyVisible) {
      priceOptions.forEach(opt => {
        opt.classList.remove('is-hidden');
        opt.classList.remove('is-disabled');
      });
    }

    if (!hasSelectedValid && this.selections.priceMin !== null) {
      this.selections.priceMin = null;
      this.selections.priceMax = null;
      this.resetStepsAfter(2);
    }
  }

  validateSubmit() {
    if (this.selections.collectionUrl && this.selections.foodPairing) {
      this.submitBtn.disabled = false;
    } else {
      this.submitBtn.disabled = true;
    }
  }

  submit() {
    let url = this.selections.collectionUrl;
    const params = [];

    if (this.selections.priceMin) {
      params.push(`filter.v.price.gte=${this.selections.priceMin}`);
    }
    if (this.selections.priceMax) {
      params.push(`filter.v.price.lte=${this.selections.priceMax}`);
    }
    if (this.selections.foodPairing) {
      params.push(`filter.p.m.custom.food_pairings=${encodeURIComponent(this.selections.foodPairing)}`);
    }

    if (params.length > 0) {
      url += (url.includes('?') ? '&' : '?') + params.join('&');
    }

    window.location.href = url;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new WineSelector();
});
